import { useCallback, useState } from "react";

import {
  BrokerageTransferEditValues,
  UseBrokerageTransferPanelReturn,
} from "./types";

/**
 * Open/closed state for the brokerage-transfer panel. A transfer row owns only
 * its compact projection, so the page fetches the transaction and hands this
 * hook the prefilled panel values when opening an edit. The target is the
 * transaction id alone — the submit path never needed the row's projection.
 */
export const useBrokerageTransferPanel =
  (): UseBrokerageTransferPanelReturn => {
    const [panel, setPanel] = useState<
      UseBrokerageTransferPanelReturn["panel"]
    >({
      isOpen: false,
      mode: "create",
      transferId: null,
      initialValues: null,
    });

    const openCreatePanel = useCallback(
      () =>
        setPanel({
          isOpen: true,
          mode: "create",
          transferId: null,
          initialValues: null,
        }),
      [],
    );
    const openEditPanel = useCallback(
      (transferId: number, initialValues: BrokerageTransferEditValues) =>
        setPanel({
          isOpen: true,
          mode: "edit",
          transferId,
          initialValues,
        }),
      [],
    );
    const closePanel = useCallback(
      () =>
        setPanel((current) => ({
          ...current,
          isOpen: false,
        })),
      [],
    );

    return { panel, openCreatePanel, openEditPanel, closePanel };
  };
